var React = require('react');

function ListicleStepArrowRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"cls-1","transform":"translate(.068 .068)"},[React.createElement("circle",{"cx":"22.5","cy":"22.5","r":"22.5","fill":"#e57c5c","data-name":"Ellipse 3","transform":"translate(-.068 -.068)","key":0}),React.createElement("g",{"fill":"none","stroke":"#fff","strokeLinecap":"round","strokeWidth":"3","className":"cls-1","data-name":"Group 294","key":1},[React.createElement("path",{"strokeLinejoin":"round","d":"m25.666 14.916 7.811 8.336-7.811 8.38","data-name":"Path 324","key":0}),React.createElement("path",{"d":"M33.476 23.278H9.251","data-name":"Path 325","key":1})])]));
}

ListicleStepArrowRight.defaultProps = {"viewBox":"0 0 45 45"};

module.exports = ListicleStepArrowRight;

ListicleStepArrowRight.default = ListicleStepArrowRight;
